import { useState } from 'react'
import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TextField from '../../../FormLegacy/FormFieldsV2/TextField'
import Icon from '../../../Icons'
import API from '../../../../api/api'

const SmsPackagesWindow = ({ isOpen, handleSubmit, handleClose }) => {
  const { t } = useTranslation(['chat'])
  const [isLoading, setLoading] = useState(false)
  const [areaCode, setAreaCode] = useState('')
  const [errorMessage, setErrorMessage] = useState(null)

  const handleCheckAreaCode = async () => {
    setLoading(true)
    try {
      await API.checkAreaCode(areaCode)
      handleSubmit(areaCode)
      handleClose()
      setLoading(false)
      setAreaCode('')
    } catch ({ response }) {
      setErrorMessage(response.data.message)
      setLoading(false)
    }
  }

  const handleTypeAreaCode = (e) => {
    setAreaCode(e.target.value)
    setErrorMessage(null)
  }

  if (!isOpen) return null
  return (
    <div className="add-new-number-window">
      <div className={`add-new-number-window__container`}>
        <div className="window-header">
          <div className="left-side">
            <div className="title">{t('chat:addNewNumber.title')}</div>
          </div>
          <div className="right-side">
            <div className="navi-button" onClick={handleClose}>
              <Icon icon="cross" />
            </div>
          </div>
        </div>
        <div className="main-view">
          <TextField
            maxLength="3"
            name="prefferedPriceOrDiscount"
            label={t('chat:addNewNumber.areaCodeLabel')}
            placeholder={t('chat:addNewNumber.areaCodePlaceholder')}
            onChange={handleTypeAreaCode}
            value={areaCode}
            type="number"
            disabled={isLoading}
            isError={!!errorMessage}
          />
          {errorMessage ? (
            <div className="information-error">{errorMessage}</div>
          ) : (
            <div className="information-tip">{t('chat:addNewNumber.info')}</div>
          )}
        </div>
        <div className="footer-view">
          <button className="button button-gray" onClick={handleClose} disabled={isLoading}>
            {t('common:actions.cancel')}
          </button>
          <button
            className="button button-primary"
            onClick={handleCheckAreaCode}
            disabled={isLoading || !areaCode}
          >
            {t('chat:addNewNumber.next')}
          </button>
        </div>
      </div>
    </div>
  )
}

SmsPackagesWindow.propTypes = {
  isOpen: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleClose: PropTypes.func,
}

export default SmsPackagesWindow
